/**
 * 料金計算
 *
 * No.    日付          更新者    更新内容
 *   1    2021/10/26   大友      新規作成
 *
 * @summary ユーティリティーフォーム関連
 * @copyright 2021, WINGSYSTEMS K.K.
 */

'use strict';

import '../../_initial';
import '../../_common';
import {BlockUI} from '../../common/blockui';
import flatpickr from 'flatpickr';
import { Input } from '../../common/input';
import { Japanese } from "flatpickr/dist/l10n/ja.js"; //日本語用モジュール

// flatpickr
// 使い方
// https://notes.sharesl.net/articles/1923/

let maxDate = new Date().fp_incr(30);

// 利用日
flatpickr('#useDateTime', {
  locale : Japanese, // 日本語用モジュールを適用
  altInput: true,
  altFormat: 'Y.m.d（D） H:i',  // 表示用 2021.05.24（月）の形式で表示
  dateFormat : 'Y-m-d H:i:00', // 実際に送信するvalue
  //defaultDate : now, // 入力エリアの初期値
  minDate     : 'today',
  maxDate     : maxDate,
  enableTime : true,
  hourIncrement: 1,
  minuteIncrement: 10,
  //defaultHour : now.getHours(),
  //defaultMinute : now.getMinutes(),
});

// 人数
Input.numericOnly('#number', false);

document.getElementById('frmSearch').addEventListener('submit', (event) => {
    BlockUI.show();
});
